const CAP14 = {
  id: 14,
  slug: "cap14-blockchain-privada",
  title: "Capítulo 14 — Características de la Blockchain Privada",
  sections: [
    {
      heading: "¿Qué es una blockchain privada?",
      text: [
        "Una **blockchain privada** es una red en la que el acceso está restringido a participantes autorizados. No es pública ni abierta a todos.",
        "Es gestionada por una entidad (empresa, institución u organización) que establece las reglas, decide quién puede participar y qué permisos tiene cada uno.",
        "Este tipo de blockchain es muy utilizada en entornos empresariales, donde se requiere **privacidad, control, rapidez y confidencialidad de los datos**."
      ]
    },
    {
      heading: "¿Por qué usar una blockchain privada?",
      text: [
        "Las organizaciones necesitan tecnología blockchain, pero no siempre quieren que los datos sean públicos.",
        "Las blockchains privadas permiten utilizar las ventajas de blockchain —como trazabilidad, seguridad, integridad y registros inmutables— sin exponer información sensible."
      ]
    },
    {
      heading: "Características principales",
      list: [
        "🔹 Solo usuarios autorizados pueden acceder a la red.",
        "🔹 Existe una entidad que gobierna o administra la red.",
        "🔹 Permiten mayor privacidad y confidencialidad de los datos.",
        "🔹 Ofrecen alto rendimiento y rapidez en transacciones.",
        "🔹 No están completamente descentralizadas (gobernanza centralizada)."
      ]
    },
    {
      heading: "Ejemplos conocidos",
      text: [
        "Algunas plataformas de blockchain privada ampliamente utilizadas son:"
      ],
      list: [
        "🔹 **Hyperledger** (enfocada en soluciones empresariales y colaboración).",
        "🔹 **Quorum** (basada en Ethereum, con mayor privacidad y permisos).",
        "🔹 Redes personalizadas creadas por instituciones, bancos, gobiernos o universidades."
      ]
    },
    {
      heading: "Ventajas de la blockchain privada",
      list: [
        "🔹 **Mayor velocidad y eficiencia:** menos nodos = procesamiento más rápido.",
        "🔹 **Privacidad:** los datos están protegidos y no se hacen públicos.",
        "🔹 **Control y gobernanza:** las organizaciones establecen reglas y permisos.",
        "🔹 **Escalabilidad y personalización:** se puede adaptar según las necesidades.",
        "🔹 **Ideal para empresas, gobiernos, salud, logística, finanzas, educación**."
      ]
    },
    {
      heading: "Desventajas de la blockchain privada",
      list: [
        "⚠️ **Menor descentralización:** existe una entidad principal que controla la red.",
        "⚠️ **Riesgo de manipulación o censura:** si la autoridad central abusa de su poder.",
        "⚠️ **Falta de transparencia pública:** dificulta auditorías externas.",
        "⚠️ **Mayor dependencia de confianza:** los participantes deben confiar en quien administra la red.",
        "⚠️ **Gobernanza jerárquica:** no todos los nodos tienen los mismos privilegios."
      ]
    },
    {
      heading: "Caso práctico explicado",
      text: [
        "Imagina una empresa de logística internacional que quiere rastrear sus envíos en tiempo real.",
        "Esa información incluye documentos de aduanas, rutas, costos, ubicación, datos de clientes, etc. No puede ser pública.",
        "Por eso, implementa una blockchain privada.",
        "🔹 Solo empleados autorizados pueden acceder.",
        "🔹 Cada envío queda registrado con fecha, ubicación, firma digital y responsable.",
        "🔹 Los datos no pueden ser alterados ni eliminados.",
        "🔹 Los clientes pueden consultar el estado del paquete, pero solo su propio envío.",
        "💡 Resultado: mayor transparencia interna, trazabilidad, seguridad documental y sin exponer información confidencial."
      ]
    },
    {
      heading: "¿Cuándo elegir blockchain privada?",
      list: [
        "🔹 Cuando se necesita **privacidad y control de datos**.",
        "🔹 Cuando las leyes exigen confidencialidad (finanzas, salud, gobierno).",
        "🔹 Cuando los participantes ya se conocen y confían entre sí.",
        "🔹 Cuando se busca velocidad, eficiencia y trazabilidad sin exposición pública."
      ]
    },
    {
      heading: "Conclusión",
      text: [
        "La blockchain privada es una gran herramienta para organizaciones que necesitan **seguridad, control, privacidad y trazabilidad**, sin exponer todo al público.",
        "No busca máxima descentralización, sino un equilibrio entre blockchain y gestión empresarial.",
        "Es ideal para soluciones internas, colaboración entre entidades confiables y sistemas donde la información es sensible."
      ]
    }
  ]
};

export default CAP14;
